export default __webpack_public_path__ + "static/media/Backup.ad0fc269.jpg";